const request = {}

request.createRequest = function (params) {
  return {
    paymentDate: params.date,
    paymentPrice: String(params.notPayAmount),
    paymentMethodId: params.method.value
  }
}
export default { request }
